__turbopack_context__.v({
  "backgroundImages": "styles-module__uMuvOq__backgroundImages",
  "container": "styles-module__uMuvOq__container",
  "content": "styles-module__uMuvOq__content",
  "ctaWrapper": "styles-module__uMuvOq__ctaWrapper",
  "heading": "styles-module__uMuvOq__heading",
  "imageItem": "styles-module__uMuvOq__imageItem",
  "leftImages": "styles-module__uMuvOq__leftImages",
  "mobileImage": "styles-module__uMuvOq__mobileImage",
  "rightImages": "styles-module__uMuvOq__rightImages",
  "subheading": "styles-module__uMuvOq__subheading",
});
